module.exports = __webpack_public_path__ + "static/Node-0eb065e0bf1060e2514ae1d4134ab507.svg";